import { render, staticRenderFns } from "./SH060ShopperInfoConfirm.vue?vue&type=template&id=700a9ea1&scoped=true&"
import script from "./SH060ShopperInfoConfirm.vue?vue&type=script&lang=js&"
export * from "./SH060ShopperInfoConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SH060ShopperInfoConfirm.vue?vue&type=style&index=0&id=700a9ea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a9ea1",
  null
  
)

export default component.exports